import React from "react";
import { Flex, Text, Button, Box } from "@chakra-ui/react";
import { ChevronLeftIcon, ChevronRightIcon } from "@chakra-ui/icons";

function GridPagination({
  currentPage,
  totalPages,
  totalElements,
  pageSize,
  onPrevious,
  onNext,
}) {
  const from = totalElements > 0 ? currentPage * pageSize + 1 : 0;
  const to   = Math.min((currentPage + 1) * pageSize, totalElements);
 
  return (
    <Flex
      justify="space-between"
      align="center"
      mt={4}
      px={{ base: 2, md: 4 }}
      flexDirection={{ base: "column", sm: "row" }}
      gap={{ base: 3, sm: 0 }}
    >
      <Text fontSize={{ base: "xs", sm: "sm" }} color="gray.600">
        Showing {from} to {to} of {totalElements} records
      </Text>
 
      <Flex gap={2} align="center">
        {/* Previous */}
        <Button
          onClick={onPrevious}
          isDisabled={currentPage === 0}
          size="sm"
          fontSize={{ base: "md", md: "lg" }}
          variant="outline"
          colorScheme="gray"
          leftIcon={<ChevronLeftIcon />}
          boxShadow="0 1px 3px rgba(0,0,0,0.1)"
          _hover={{ boxShadow: "0 2px 6px rgba(0,0,0,0.15)" }}
          _disabled={{ opacity: 0.4, cursor: "not-allowed", boxShadow: "none" }}
        >
          Previous
        </Button>
 
        {/* Current page badge */}
        <Flex
          align="center"
          justify="center"
          bg="red.500"
          color="white"
          w={{ base: "32px", md: "40px" }}
          h={{ base: "32px", md: "40px" }}
          borderRadius="md"
          fontWeight="bold"
          fontSize={{ base: "sm", md: "md" }}
          boxShadow="0 2px 4px rgba(199,33,39,0.3)"
        >
          {currentPage + 1}
        </Flex>
 
        {/* Next */}
        <Button
          onClick={onNext}
          isDisabled={currentPage >= totalPages - 1}
          size="sm"
          fontSize={{ base: "md", md: "lg" }}
          variant="outline"
          colorScheme="gray"
          rightIcon={<ChevronRightIcon />}
          boxShadow="0 1px 3px rgba(0,0,0,0.1)"
          _hover={{ boxShadow: "0 2px 6px rgba(0,0,0,0.15)" }}
          _disabled={{ opacity: 0.4, cursor: "not-allowed", boxShadow: "none" }}
        >
          Next
        </Button>
      </Flex>
    </Flex>
  );
}
 
export default GridPagination;